<template>
  <v-row no-gutters class="inline-flex align-content-start card-container unselectable">
    <v-col cols="12"
           class="header-container d-flex align-center justify-center std-text-lg std-text-white-1 font-weight-bold">
      {{name}}
    </v-col>
    <v-row class="px-4 pt-2 justify-center" no-gutters>
      <v-col cols="12"
             class="card-description-text description-container mb-2 text-center">
        {{description}}
      </v-col>
      <SystemCardCount title="No. de animales"
                       width="240px"
                       numberBackground="#1460AA"
                       titleBackground="#57A7F5"
                       :number="number"
                       height="40px">
      </SystemCardCount>
      <v-col cols="12" class="indicator-container d-flex">
        <div class="col-5 pa-0 d-flex align-center justify-center">
          <v-img :src="image"
                 contain
                 height="90px"
                 width="90px"></v-img>
        </div>
        <div class="col-7 d-flex flex-wrap px-0 align-content-center">
          <div class="col-12 top-text-indicator d-flex justify-center align-center pa-0 std-text-md font-weight-regular">
            Vacas en celo
          </div>
          <div class="col-12 bottom-text-indicator d-flex justify-center align-center pa-0 std-text-md font-weight-bold">
            {{number}}
          </div>
        </div>
      </v-col>
    </v-row>
    <v-col cols="12"
           @click="openGroup()"
           v-ripple
           class="footer-container d-flex align-center justify-center std-text-md std-text-blue-1 font-weight-regular std-pointer">
      <div class="d-flex align-center">Ver más<i class="eye-indicator ml-3"></i></div>
    </v-col>
  </v-row>
</template>

<script>
    import SystemCardCount from "./SystemCardCount";
    import {EventBus} from '@/views/bus.js';
    export default {
      name: "CardItemGroup",
      components: {SystemCardCount},
      props: ['name', 'description', 'indicator', 'number', 'image', 'showMore', 'group'],
      methods: {
        openGroup() {
          EventBus.$emit('openIndividualGroup', {group: this.group, edit: this.name === 'Establo general'});
        }
      }
    }
</script>

<style scoped>

  .card-container {
    background-color: #ffffff;
    width: 100%;
    height: 100%;
    border-radius: 4px;
  }

  .description-container {
    height: 72px;
    overflow-y: auto;
  }

  .indicator-container {
    height: 111px;
  }

  .header-container {
    height: 48px;
    border-radius: 4px 4px 0 0;
    background-color: var(--smartbell-blue-2);
  }

  .footer-container {
    height: 48px;
    box-shadow: 0 0 2px rgba(0, 0, 0, 0.25);
    background-color: var(--smartbell-grey-1);
    border-radius: 0 0 4px 4px;
  }


  .card-description-text {
    font-size: 1rem;
    color: var(--smartbell-grey-2);
    text-align: left;
  }

  .heat-indicator {
    background: url("../assets/card_item_group/heat_indicator.png") no-repeat;
    height: 100px;
    width: 100px;
    object-fit: cover;
    display: inline-flex;
  }

  .top-text-indicator {
    height: 40%;
    color: var(--smartbell-blue-2);
  }

  .bottom-text-indicator {
    height: 40%;
    color: var(--smartbell-blue-2);
  }



</style>